import { clientConverter } from '@maru44/huntre-utils/src/models/client'
import { doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore'
import { useCallback } from 'react'
import { NotFoundError } from 'src/utils/error'
import { firestore } from 'src/utils/firebase'

type UpdateClientInput = {
  name: string
  iconURL: string
  address: string
}

export const useUpdateClient = (id: string) => {
  const updateClient = useCallback(
    async (input: UpdateClientInput) => {
      const ref = doc(firestore, `clients/${id}`).withConverter(clientConverter)
      const snap = await getDoc(ref)
      if (!snap.exists) {
        throw new NotFoundError('client', id)
      }

      await updateDoc(ref, {
        ...input,
        updatedAt: serverTimestamp(),
      })
    },
    [id],
  )

  const clearClientLineTarget = useCallback(async () => {
    const ref = doc(firestore, `clients/${id}`)
    await updateDoc(ref, { lineTarget: null, updatedAt: serverTimestamp() })
  }, [id])

  return { updateClient, clearClientLineTarget }
}
